import { toUnmatchedFee, UnmatchedFeeValue } from './unmatched-fee.util';

export interface FeePerItemPayload {
  enabled?: boolean;
  byProductGroup?: boolean;
  feeRules?: unknown[];
  groupRules?: unknown[];
  unmatchedFee?: UnmatchedFeeValue | unknown;
}

// Shared by the save payload and the change review, so both sides of the diff carry the same shape.
export function normaliseFeePerItem<T extends FeePerItemPayload>(feePerItem: T): T {
  return { ...feePerItem, unmatchedFee: toUnmatchedFee(feePerItem.unmatchedFee as UnmatchedFeeValue) };
}

// The rules of the mode that is not pricing are parked, not deleted: they are kept so switching
// back restores them. Stripping them is what the server needs, so it happens on the way out and
// not in the payload the review diffs — otherwise changing mode reads as deleting every rule.
export function feePerItemForSave<T extends FeePerItemPayload>(feePerItem: T): T {
  const forSave = { ...feePerItem };
  if (!forSave.enabled || !forSave.byProductGroup) {
    forSave.groupRules = [];
  } else {
    delete forSave.feeRules;
  }
  return forSave;
}
